<template>
  <v-alert
    v-if="provider.emergency_response_types.length > 0 || provider.emergency_response_description"
    id="emergency-response-alert"
    border="start"
    border-color="primary"
    class="w-100pc flex-fill"
    color="primary"
    style="background-color: white"
    type="info"
    variant="outlined"
    text
  >
    <div class="mb-2 fw-500">
      {{ $bct('Changes made in response to COVID-19') }}
    </div>
    <div
      v-if="provider.emergency_response_types.length > 0"
      class="mb-2"
    >
      <span class="fs-16 fw-400">
        {{ $bct('We are currently implementing the following changes in response to COVID-19:') }}
      </span>
      <ul>
        <li
          v-for="responseType in provider.emergency_response_types"
          :key="responseType"
          class="fs-16 fw-400"
        >
          {{ $bct(responseType) }}
        </li>
      </ul>
    </div>
    <div v-if="provider.emergency_response_description">
      {{ $bct(provider.emergency_response_description) }}
    </div>
  </v-alert>
</template>

<script setup>
defineProps({
  provider: {
    type: Object,
    default: null,
  },
});

const $bct = inject('translator');
</script>
